import { render, staticRenderFns } from "./XCard.vue?vue&type=template&id=52e7792a&scoped=true"
import script from "./XCard.vue?vue&type=script&lang=js"
export * from "./XCard.vue?vue&type=script&lang=js"
import style0 from "./XCard.vue?vue&type=style&index=0&id=52e7792a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e7792a",
  null
  
)

export default component.exports